<template>
    <page :showBackButton="true">
        <slider :slides="slides" />
        <ion-grid>
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'berater' }"
                        icon="icon-berater"
                        title="Berater"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung' }"
                        icon="icon-schadensmeldung"
                        title="Schadensmeldung"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'dokbox' }"
                        icon="icon-dokbox"
                        title="DokBox"
                    />
                </ion-col>
                <ion-col size="4" v-if="hasUnwetter">
                    <pagelink
                        :path="{ name: 'services-unwetterwarnung' }"
                        icon="icon-unwetterwarnung"
                        title="Unwetterwarnung"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Slider from "@/components/Slider";
import Pagelink from "@/components/Pagelink";

export default {
    components: {
        Page,
        Slider,
        Pagelink
    },
    mounted() {
        this.$store.dispatch("slidesConfig/getSlidesConfig");
    },
    computed: {
        slides() {
            let result = [];
            if ("services" in this.$store.state.slidesConfig.all) {
                result = this.$store.state.slidesConfig.all.services;
            }
            return result;
        },
        hasUnwetter() {
            let result = false;
            let contracts = this.$store.state.contracts;
            for (let key in contracts) {
                if (
                    contracts[key].hasOwnProperty("Features") &&
                    contracts[key].Features.hasOwnProperty("Unwetter")
                ) {
                    result = true;
                    break;
                }
            }
            return result;
        }
    }
};
</script>

<style></style>
